<template>
  <ul class="notification-list">
    <li
      v-for="(notification, index) in notifications"
      :key="notification._id || index"
      class="notification-list__item"
    >
      <div class="d-flex align-items-start gap-3">
        <span class="notification-list__icon" aria-hidden="true">
          <i class="el-icon-chat-dot-round"></i>
        </span>
        <div class="notification-list__content">
          <h6 class="notification-list__title">{{ notification.nombre }}</h6>
          <time
            v-if="notification.createdAt"
            :datetime="notification.createdAt"
            class="notification-list__date"
          >{{ formatDate(notification.createdAt) }}</time>
          <p class="notification-list__text">{{ notification.texto }}</p>
          <el-button
            v-if="notification.adjunto"
            type="text"
            size="small"
            icon="el-icon-download"
            class="p-0 mt-2 icono-accion"
            :loading="downloadingId === notification._id"
            :disabled="!!downloadingId && downloadingId !== notification._id"
            @click="$emit('download', notification._id)"
          >Descargar adjunto</el-button>
        </div>
      </div>
    </li>
  </ul>
</template>

<script>
import moment from "moment";

export default {
  name: "NotificationList",
  props: {
    notifications: { type: Array, default: () => [] },
    downloadingId: { type: String, default: null },
  },
  methods: {
    formatDate(value) {
      const date = moment(value);
      return date.isValid() ? date.format("DD/MM/YYYY HH:mm") : "";
    },
  },
};
</script>

<style lang="scss" scoped>
.notification-list {
  list-style: none;
  margin: 0;
  padding: 8px;
}

.notification-list__item {
  padding: 16px 12px;
  border-radius: 12px;

  &:hover {
    background-color: #f7f9fc;
  }
}

.notification-list__icon {
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 10px;
  background: #edf3ff;
  color: #447df7;
  font-size: 18px;
}

.notification-list__content {
  min-width: 0;
  flex: 1;
  overflow-wrap: anywhere;
}

.notification-list__title {
  margin: 0;
  color: #303133;
  font-size: 14px;
  line-height: 1.5;
  text-transform: none;
}

.notification-list__date {
  display: block;
  margin-top: 2px;
  color: #909399;
  font-size: 12px;
}

.notification-list__text {
  margin: 8px 0 0;
  color: #606266;
  font-size: 14px;
  line-height: 1.6;
  white-space: pre-wrap;
}
</style>
